import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  Label,
  Table,
  Spinner,
} from "reactstrap";

import swal from "sweetalert";
import axiosConfig from "../../AxiosConfig";

export default function ProductSaction() {

  const [loading, setLoading] = useState(false);

  // =========================================
  // MULTIPLE FORM ROWS
  // =========================================

  const [formRows, setFormRows] = useState([
    {
      productType: "",
      status: "Active",
    },
  ]);

  // =========================================
  // TABLE DATA
  // =========================================

  const [rowData, setRowData] = useState([]);

  // =========================================
  // HANDLE CHANGE
  // =========================================

  const handleChange = (
    index,
    e
  ) => {

    const { name, value } = e.target;

    const updatedRows = [...formRows];

    updatedRows[index][name] = value;

    setFormRows(updatedRows);
  };

  // =========================================
  // ADD MORE
  // =========================================

  const addMoreRows = () => {

    setFormRows([
      ...formRows,
      {
        productType: "",
        status: "Active",
      },
    ]);
  };

  // =========================================
  // REMOVE ROW
  // =========================================

  const removeRow = (index) => {

    const updatedRows = [...formRows];

    updatedRows.splice(index, 1);

    setFormRows(updatedRows);
  };

  // =========================================
  // FETCH TABLE DATA
  // =========================================

  const fetchData = async () => {

    try {

      setLoading(true);

      const user = JSON.parse(
        localStorage.getItem("userData")
      );

      const db = user?.database;

      const res = await axiosConfig.get(
        `/product-type/view-producttype/${db}`
      );
      console.log("TABLE DATA", res);
      setRowData(
        res?.data?.productType || []
      );

    } catch (err) {

      console.log(err);

    } finally {

      setLoading(false);
    }
  };

  useEffect(() => {

    fetchData();

  }, []);

  // =========================================
  // SAVE
  // =========================================

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      const user = JSON.parse(
        localStorage.getItem("userData")
      );

      // =========================================
      // LOOP ALL ROWS
      // =========================================

      for (const item of formRows) {

        const payload = {
          producttype: item?.productType,
          status: item?.status,
          database: user?.database,
          created_by: user?._id,
        };

        console.log("PAYLOAD", payload);
        await axiosConfig.post(
          "/product-type/save-producttype",
          payload
        );
      }

      swal(
        "Success",
        "Product Section Added Successfully",
        "success"
      );

      // =========================================
      // RESET FORM
      // =========================================

      setFormRows([
        {
          productType: "",
          status: "Active",
        },
      ]);

      // =========================================
      // REFRESH TABLE
      // =========================================

      fetchData();

    } catch (err) {

      console.log(err);

      swal(
        "Error",
        err?.response?.data?.message ||
        "Something Went Wrong",
        "error"
      );

    } finally {

      setLoading(false);
    }
  };

  // =========================================
  // DELETE
  // =========================================

  const handleDelete = async (id) => {

    swal(
      "Warning",
      "Sure You Want To Delete?",
      {
        buttons: {
          cancel: "Cancel",
          delete: {
            text: "Delete",
            value: "delete",
          },
        },
      }
    ).then(async (value) => {

      if (value === "delete") {

        try {

          const res = await axiosConfig.delete(
            `/product-type/delete-producttype/${id}`
          );
          if (res?.data?.status) {

            swal(
              "Success",
              "Deleted Successfully",
              "success"
            );

            // =========================
            // REMOVE DATA INSTANTLY
            // =========================

            setRowData((prev) =>
              prev.filter(
                (item) => item._id !== id
              )
            );

          } else {

            swal(
              "Error",
              "Delete Failed",
              "error"
            );
          }

        } catch (err) {

          console.log(err);

          swal(
            "Error",
            "Something Went Wrong",
            "error"
          );
        }
      }
    });
  };

  return (
    <div className="erp-page-grid">

      {/* ========================================= */}
      {/* HEADER */}
      {/* ========================================= */}

      <Row
        style={{
          marginBottom: "15px",
          alignItems: "center",
        }}
      >
        <Col md="12">
          <h2>Product Saction</h2>
        </Col>
      </Row>

      {/* ========================================= */}
      {/* FORM */}
      {/* ========================================= */}

      <Card>

        <CardBody>

          <form onSubmit={handleSubmit}>

            {formRows.map(
              (item, index) => (

                <Row
                  key={index}
                  className="mb-2"
                >

                  {/* PRODUCT TYPE */}

                  <Col md="5">

                    <Label>
                      Product Type
                    </Label>

                    <Input
                      type="text"
                      name="productType"
                      placeholder="Enter Product Type"
                      value={item?.productType}
                      onChange={(e) =>
                        handleChange(
                          index,
                          e
                        )
                      }
                      required
                    />

                  </Col>

                  {/* STATUS */}

                  <Col md="4">

                    <Label>
                      Status
                    </Label>

                    <Input
                      type="select"
                      name="status"
                      value={item?.status}
                      onChange={(e) =>
                        handleChange(
                          index,
                          e
                        )
                      }
                    >
                      <option value="Active">
                        Active
                      </option>

                      <option value="Deactive">
                        Deactive
                      </option>
                    </Input>

                  </Col>

                  {/* ACTION */}

                  <Col
                    md="3"
                    className="d-flex align-items-end"
                  >

                    {index === 0 ? (

                      <Button
                        color="primary"
                        type="button"
                        onClick={addMoreRows}
                      >
                        + Add More
                      </Button>

                    ) : (

                      <Button
                        color="danger"
                        type="button"
                        onClick={() =>
                          removeRow(index)
                        }
                      >
                        Remove
                      </Button>

                    )}

                  </Col>

                </Row>
              )
            )}

            <div className="mt-3">

              <Button
                color="success"
                type="submit"
                disabled={loading}
              >
                {loading
                  ? "Saving..."
                  : "Save"}
              </Button>

            </div>

          </form>

        </CardBody>

      </Card>

      {/* ========================================= */}
      {/* TABLE */}
      {/* ========================================= */}

      <Card className="mt-2">

        <CardBody>

          {loading ? (

            <div
              style={{
                textAlign: "center",
              }}
            >
              <Spinner />
            </div>

          ) : (

            <Table bordered responsive>

              <thead>

                <tr>
                  <th>#</th>
                  <th>Product Type</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>

              </thead>

              <tbody>

                {rowData?.length > 0 ? (

                  rowData.map((item, index) => (

                    <tr key={item?._id}>

                      <td>
                        {index + 1}
                      </td>

                      <td>
                        {item?.producttype}
                      </td>

                      <td>
                        {item?.status}
                      </td>

                      <td>

                        <Button
                          color="danger"
                          size="sm"
                          onClick={() =>
                            handleDelete(item?._id)
                          }
                        >
                          Delete
                        </Button>

                      </td>

                    </tr>
                  ))

                ) : (

                  <tr>

                    <td
                      colSpan="4"
                      className="text-center"
                    >
                      No Data Found
                    </td>

                  </tr>
                )}

              </tbody>

            </Table>
          )}

        </CardBody>

      </Card>

    </div>
  );
}